var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"content"},[_c('hi'),_c('main',[_c('About'),_c('Friends'),_c('Help'),_c('Donation')],1),_c('Contacts')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }